import BaseObjectDirective from '../../contentobjects/BaseObjectDirective';

/**
 * IbTextCompiler class is responsible for compiling text directives in an AngularJS application.
 * It handles dynamic HTML content and applies specific styles based on configuration and language settings.
 */
export class IbTextCompiler {
    /**
     * Constructor for IbTextCompiler class.
     * @param {Object} $compile - AngularJS compile service.
     * @param {Object} $ - jQuery or a similar DOM manipulation library.
     * @param {Object} $bridges - Service for handling communication with external systems or components.
     * @param {Object} $config - Configuration settings for the application.
     * @param {Object} $rootScope - AngularJS root scope.
     */
    constructor($compile, $, $bridges, $config, $rootScope) {
        this.$compile = $compile;
        this.$ = $;
        this.$bridges = $bridges;
        this.$config = $config;
        this.$rootScope = $rootScope;
        this._logIdentifier = 'ibTextCompiler';
    }

    /**
     * Defines and returns the directive configuration object.
     * @returns {Object} - Directive configuration.
     */
    directive() {
        return {
            restrict: 'A',
            replace: true,
            link: (scope, element, attrs) => {
                //scope.$watch(() => attrs.ibTextCompiler, (html) => {
                scope.$watch(attrs.ibTextCompiler, (html) => {
                  
                    element.html(html);

                    const isPDFMode = this.$config.isPDFMode();
                    const langISO = attrs.ibTextCompilerLangIso;
                    if (!this.$rootScope.isJournal) {
                        if (isPDFMode && langISO === 'ar_AR') {
                            element.addClass("arabic-pdf-font");
                        }
                        if (isPDFMode && langISO === 'hi_HI') {
                            element.addClass("hindi-pdf-font");
                        }
                        if (langISO === 'ur_UR') {
                            element.addClass("urdu-font-force");
                        }
                    }
                    if (isPDFMode && langISO === 'ur_UR') {
                        element.addClass("urdu-pdf-font");
                    }

                    if (angular.isDefined(attrs.ibTextCompilerBindinputs)) {
                        const inputs = element.find("input"),
                            selects = element.find("select"),
                            isInvalidElement = (inputElement) => {
                                try {
                                    const parents = $(inputElement).val();
                                    return false;
                                } catch (e) {
                                    console.log("Can't touch element " + inputElement + ": " + e);
                                    return true;
                                }
                            },
                            reg = (inputElement) => {
                                if (isInvalidElement(inputElement)) {
                                    console.log("NOT Registering autosave for invalid input element (in SVG maybe?): " + inputElement);
                                    return;
                                }
                                BaseObjectDirective.asfAutoSaveResponseInputLink(scope, $(inputElement), {});

                                if (angular.element(inputElement).prop("tagName") === 'INPUT') {
                                    angular.element(inputElement).off('focus');
                                    angular.element(inputElement).on('focus', () => {
                                        this.$bridges.runtime().setLastKeyboardLanguage();
                                    });
                                }
                            };

                        angular.forEach(inputs, reg);
                        angular.forEach(selects, reg);
                    }

                    this.$compile(element.contents())(scope);
                });
            }
        };
    }
}

export default function registerTextCompilerDirective(angular) {
    angular.module("assessmentFrontendDirectives")
        .directive('ibTextCompiler', ['$compile', '$', '$bridges', '$config', '$rootScope', 
            ($compile, $, $bridges, $config, $rootScope) => {
                return new IbTextCompiler($compile, $, $bridges, $config, $rootScope).directive();
            }
        ]);
}